module.exports = __webpack_public_path__ + "static/media/gameStand.7750dcbb.png";